// @ts-nocheck -- RARE-264 mechanical rename; type this file under RARE-265
import { CButton } from "@coreui/react-pro";
import { useLogto } from "@logto/react";
import { Link, useOutletContext, useSearchParams } from "react-router-dom";
import { captureReturnTo } from "../../graphql/policies/auth";

const LogTo = () => {
  const { signIn } = useLogto();
  const { from } = useOutletContext() ?? {};
  const handleSignIn = () => {
    // Re-stash immediately before the redirect. `captureReturnTo` at
    // sign-out already wrote this, but a user can also arrive at
    // /login by navigating here directly, in which case `from` came
    // from router state and has never been persisted. Writing it here
    // is the last point at which we still know it: signIn takes the
    // browser off the origin entirely.
    captureReturnTo(from);
    signIn(`${window.location.origin}/callback`);
  };
  const [searchParams] = useSearchParams();

  return (
    <>
      <div>
        <p className="text-medium-emphasis">
          Continue to the secure single sign-on page to access your Rare Monitor account.
        </p>
        <CButton color="primary" size="lg" className="mt-2" onClick={handleSignIn}>
          Sign in with Logto
        </CButton>
      </div>
      {(searchParams.has("emailLogin") || import.meta.env.MODE !== "production") && (
        <p className={"mt-4"}>
          <Link to={"email"}>Or sign in with an e-mail and password</Link>
        </p>
      )}
    </>
  );
};

export default LogTo;
